import type { SerializedError } from "@reduxjs/toolkit";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { toast } from "../lib/toast";
import type { ApiErrorType } from "../types/global.types";

export const errorToast = (
  error: FetchBaseQueryError | SerializedError | unknown | undefined,
  message: string,
) => {
  if (error) {
    // console.error(error);
    const err = error as ApiErrorType;
    // console.log(err.data?.message);
    const msg = err?.data?.error?.message || err?.data?.message;
    toast("error", msg && typeof msg === "string" ? msg : message);
  }
};
